import React from 'react'
import Navbar from '../../components/Navbar'
import Footer from '../../components/Footer'
import { Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { SiteCard } from './ProductShowcase'

const SITES = [
  { location: 'Garh Mukhteshwar, UP (Phase I)', production: '12 Rooms × 50 tons', redirect: 'garhmukhteshwar', imagePath: '/machines-images/Mushroom Farms/garhmukhteshwar.jpg' },
  { location: 'Garh Mukhteshwar, UP (Phase II)', production: '12 + 6 Rooms × 50 tons', redirect: 'garhmukhteshwar-phase2', imagePath: '/machines-images/Mushroom Farms/garhmukhteshwar.jpg' },
  { location: 'Agra, UP', production: '10 Rooms × 50 tons', redirect: 'agra', imagePath: '/machines-images/Mushroom Farms/agra.png' },
  { location: 'Samalkha, Haryana', production: '8 Rooms × 25 tons', redirect: 'samalkha', imagePath: '/machines-images/Mushroom Farms/samalkha.jpg' },
  { location: 'Murthal, Haryana', production: '2 Rooms × 20 tons', redirect: 'murthal', imagePath: '/machines-images/Mushroom Farms/murthal.jpg' },
]

function Mushroomfarms() {
  const navigate = useNavigate()

  return (
    <>
      <Navbar />

      <main className='page-shell'>
        <div className='page-title-block'>
          <Typography className='page-title'>Climate Control for Mushroom Farms</Typography>
          <Typography className='page-subtitle'>
            Growing rooms and tunnels with simultaneous temperature, humidity and CO₂ control.
          </Typography>
        </div>

        <div className='pp-site-grid'>
          {SITES.map((site) => (
            <SiteCard
              key={site.redirect}
              image={site.imagePath}
              title={site.location}
              caption={site.production}
              onOpen={() => navigate('/product/mushroomfarms/' + site.redirect)}
            />
          ))}
        </div>
      </main>

      <Footer />
    </>
  )
}

export default Mushroomfarms
